import { useState } from "react";

interface Props {
  title: string;
  onCopied: (message: string) => void;
}

export default function ShareBar({ title, onCopied }: Props) {
  const [open, setOpen] = useState(false);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      onCopied("链接已复制到剪贴板");
    } catch {
      onCopied("复制失败，请手动复制地址栏链接");
    }
    setOpen(false);
  };

  const channels = [
    { label: "微信", icon: "ri-wechat-line", color: "bg-accent-500" },
    { label: "微博", icon: "ri-weibo-line", color: "bg-accent-600" },
    { label: "QQ", icon: "ri-qq-line", color: "bg-primary-500" },
    { label: "空间", icon: "ri-planet-line", color: "bg-secondary-500" },
  ];

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={handleCopy}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-link" />
          复制链接
        </button>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-share-forward-line" />
          分享到
        </button>
      </div>

      {open && (
        <>
          <button
            type="button"
            aria-label="关闭分享面板"
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-40 cursor-default"
          />
          <div className="absolute left-0 top-full z-50 mt-2 w-56 rounded-lg border border-background-200 bg-background-50 p-3 shadow-lg">
            <p className="mb-2 px-1 text-xs text-foreground-400">分享《{title.slice(0, 12)}…》</p>
            <div className="grid grid-cols-4 gap-2">
              {channels.map((c) => (
                <button
                  key={c.label}
                  type="button"
                  onClick={() => {
                    setOpen(false);
                    onCopied("分享功能为演示，链接已复制，可粘贴到对应平台");
                  }}
                  className="flex flex-col items-center gap-1 rounded-md p-1.5 transition-colors hover:bg-background-100"
                >
                  <span className={`flex h-8 w-8 items-center justify-center rounded-lg text-background-50 ${c.color}`}>
                    <i className={c.icon} />
                  </span>
                  <span className="text-xs text-foreground-600">{c.label}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}